import { render, staticRenderFns } from "./AddressValidation.vue?vue&type=template&id=b8a6770a"
import script from "./AddressValidation.vue?vue&type=script&lang=js"
export * from "./AddressValidation.vue?vue&type=script&lang=js"
import style0 from "./AddressValidation.vue?vue&type=style&index=0&id=b8a6770a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports